import { createId, FileType, Nullable } from "@tager/admin-services";
import { SingleFileInputValueType } from "@tager/admin-ui";
import {
  FieldShortType,
  FieldUnion,
  OutgoingValueUnion,
  RepeaterOutgoingValue,
  universalFieldUtils,
} from "@tager/admin-dynamic-field";

export function createFileInputValue(
  file: Nullable<FileType>
): Nullable<SingleFileInputValueType> {
  return file
    ? {
        id: createId(),
        file,
        caption: null,
      }
    : null;
}

export function createGalleryFileInputValue(
  fileInfo: Nullable<{ file: FileType } & { description: string }>
): Nullable<SingleFileInputValueType> {
  return fileInfo
    ? {
        id: createId(),
        file: fileInfo.file,
        caption: fileInfo.description,
      }
    : null;
}

export function convertFieldUnionToArrayOfInputs<T>(
  inputValues: FieldUnion
): Array<T> {
  const outgoingValue = universalFieldUtils.getOutgoingValue(
    inputValues
  ) as RepeaterOutgoingValue;

  function convertShortFieldArrayToObject(
    fieldList: Array<FieldShortType<OutgoingValueUnion>>
  ): unknown {
    return fieldList.reduce((result, currentFieldValue) => {
      return {
        ...result,
        [currentFieldValue.name]: Array.isArray(currentFieldValue.value)
          ? (currentFieldValue.value as RepeaterOutgoingValue).map(
              (repeaterChild) => convertShortFieldArrayToObject(repeaterChild)
            )
          : currentFieldValue.value,
      };
    }, {});
  }

  return outgoingValue.map(
    (childField) => convertShortFieldArrayToObject(childField) as T
  );
}

export function getWebsiteOrigin(): string {
  return process.env.VUE_APP_WEBSITE_URL || window.location.origin;
}
